import { useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";

import { CourseEnum, RoleEnum } from "../enums";
import { useSelector } from "react-redux";
import { State, UserProfileDto } from "../interfaces";
import { SelectListDto } from "../models";

export const Navdata = () => {
  //#region hooks

  const history = useHistory();
  const { response: user } = useSelector(
    (state: any): State<UserProfileDto> => state.account.userProfile
  );
  //#endregion

  //#region

  const [isDashboard, setIsDashboard] = useState(false);
  const [isUsers, setIsUsers] = useState(false);
  const [isSubjects, setIsSubjects] = useState(false);
  const [isArea, setIsArea] = useState(false);
  const [isOlympiad, setIsOlympiad] = useState(false);
  const [isSemester, setIsSemester] = useState(false);
  const [isControl, setIsControl] = useState(false);
  const [isPayment, setIsPayment] = useState(false);
  const [iscurrentState, setIscurrentState] = useState("dashboard");
  const [isLevel1, setIsLevel1] = useState(false);
  const [isNotifications, setIsNotifications] = useState(false);
  const [isComplaints, setIsComplaints] = useState(false);
  const [isReports, setIsReports] = useState(false);
  const [isPlans, setIsPlans] = useState<boolean>(false);

  //#endregion

  //#region redux state

  //#endregion

  function updateIconSidebar(e: any) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul: any = document.getElementById("two-column-menu");
      const iconItems: any = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id)?.classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "dashboard") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "users") {
      setIsUsers(false);
    }
    if (iscurrentState !== "subjects") {
      setIsSubjects(false);
    }
    if (iscurrentState !== "areas") {
      setIsArea(false);
    }
    if (iscurrentState !== "olympiad") {
      setIsOlympiad(false);
    }
    if (iscurrentState !== "semester") {
      setIsSemester(false);
    }
    if (iscurrentState !== "payment") {
      setIsPayment(false);
    }
    if (iscurrentState !== "notifications") {
      setIsNotifications(false);
    }
    if (iscurrentState !== "complaints") {
      setIsComplaints(false);
    }
    if (iscurrentState !== "reports") {
      setIsReports(false);
    }
  }, [
    history,
    iscurrentState,
    isDashboard,
    isUsers,
    isSubjects,
    isArea,
    isOlympiad,
    isSemester,
    isNotifications,
    isComplaints,
    isReports,
  ]);

  const superAdminMenuItems: any = () => [
    {
      label: "menu",
      isHeader: true,
    },
    {
      id: "dashboard",
      label: "dashboard",
      icon: "ri-apps-2-line",
      link: "/dashboard",
      stateVariables: isDashboard,
      click: function (e: any) {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("dashboard");
        updateIconSidebar(e);
      },
    },
    {
      id: "users",
      label: "users",
      icon: "ri-user-fill",
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setIsUsers(!isUsers);
        setIscurrentState("users");
        updateIconSidebar(e);
      },
      stateVariables: isUsers,
      subItems: [
        {
          id: "cp",
          label: "cpUsers",
          link: "/users/cp-users/teachers",
          parentId: "users",
        },
        {
          id: "appUsers",
          label: "appUsers",
          link: "/#",
          isChildItem: true,
          click: function (e: any) {
            e.preventDefault();
            setIsLevel1(!isLevel1);
          },
          stateVariables: isLevel1,
          childItems: [
            { id: 1, label: "students", link: "/users/app-users/students-v2" },
            { id: 2, label: "parents", link: "/users/app-users/parents" },
            { id: 3, label: "teachers", link: "/users/app-users/teachers" },
          ],
        },
      ],
    },
    {
      id: "subjects",
      label: "subjects",
      icon: "ri-book-2-fill",
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setIsSubjects(!isSubjects);
        setIscurrentState("subjects");
        updateIconSidebar(e);
      },
      stateVariables: isSubjects,
      subItems: [
        {
          id: "first",
          label: "firstCourse",
          link: `/subjects/${CourseEnum.FIRST_COURSE}`,
          parentId: "subjects",
        },
        {
          id: "second",
          label: "secondCourse",
          link: `/subjects/${CourseEnum.SECOND_COURSE}`,
          parentId: "subjects",
        },
      ],
    },

    {
      id: "area",
      label: "areas",
      icon: "ri-road-map-fill",
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setIsArea(!isArea);
        setIscurrentState("areas");
        updateIconSidebar(e);
      },
      stateVariables: isArea,
      subItems: [
        {
          id: "governorates",
          label: "governorates",
          link: "/governorates",
          parentId: "area",
        },
        {
          id: "city",
          label: "cities",
          link: "/cities",
          parentId: "area",
        },
        {
          id: "schools",
          label: "schools",
          link: "/schools",
          parentId: "area",
        },
      ],
    },
    {
      id: "control",
      label: "controlApp",
      icon: "ri-equalizer-fill",
      link: "/#",
      stateVariables: isControl,
      click: function (e: any) {
        e.preventDefault();
        setIsControl(!isControl);
        setIscurrentState("control");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "content",
          label: "contentAndPrice",
          link: "/control-app/content-price",
          parentId: "control",
        },
        {
          id: "settings",
          label: "enableDisable",
          link: "/control-app/enable-disable",
          parentId: "control",
        },
        {
          id: "aiSetup",
          label: "AISetup",
          link: "/control-app/ai-setup",
          parentId: "control",
        },
      ],
    },
    {
      id: "olympiad",
      label: "olympiad",
      icon: "ri-trophy-line",
      link: "/olympiad",
      click: function (e: any) {
        e.preventDefault();
        setIsOlympiad(!isOlympiad);
        setIscurrentState("olympiad");
        updateIconSidebar(e);
      },
    },
    {
      id: "semester",
      label: "semesters",
      icon: "ri-calendar-line",
      link: "/semesters",
      click: function (e: any) {
        e.preventDefault();
        setIsSemester(!isSemester);
        setIscurrentState("semester");
        updateIconSidebar(e);
      },
    },
    {
      id: "payment",
      label: "payment",
      icon: "ri-wallet-fill",
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setIsPayment(!isPayment);
        setIscurrentState("payment");
        updateIconSidebar(e);
      },
      stateVariables: isPayment,
      subItems: [
        {
          id: "transactionHistory",
          label: "transactionHistory",
          link: "/payment/transaction-history",
          parentId: "payment",
        },
        {
          id: "promoCode",
          label: "promoCodes",
          link: "/payment/promo-codes",
          parentId: "payment",
        },
        {
          id: "plans",
          label: "plans",
          link: "/payment/plans",
          parentId: "payment",
          isChildItem: true,
          click: function (e: any) {
            e.preventDefault();
            setIsPlans(!isPlans);
          },
          stateVariables: isPlans,
          childItems: [
            {
              id: "first",
              label: "firstCourse",
              link: `/payment/plans/${CourseEnum.FIRST_COURSE}`,
              parentId: "payment",
            },
            {
              id: "second",
              label: "secondCourse",
              link: `/payment/plans/${CourseEnum.SECOND_COURSE}`,
              parentId: "payment",
            },
          ],
        },
      ],
    },
    {
      id: "notifications",
      label: "notifications",
      icon: "ri-notification-2-fill",
      link: "/#",
      stateVariables: isNotifications,
      click: function (e: any) {
        e.preventDefault();
        setIsNotifications(!isNotifications);
        setIscurrentState("notifications");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "notify",
          label: "notify",
          link: "/notifications/notify",
          parentId: "notifications",
        },
        {
          id: "list",
          label: "list",
          link: "/notifications/list",
          parentId: "notifications",
        },
      ],
    },
    {
      id: "complaints",
      label: "complaints",
      icon: "ri-feedback-fill",
      link: "/complaints",
      stateVariables: isComplaints,
      click: function (e: any) {
        e.preventDefault();
        setIsComplaints(!isComplaints);
        setIscurrentState("complaints");
        updateIconSidebar(e);
      },
    },
    {
      id: "reports",
      label: "reports",
      icon: "ri-file-chart-fill",
      link: "/reports",
      stateVariables: isReports,
      click: function (e: any) {
        e.preventDefault();
        setIsReports(!isReports);
        setIscurrentState("reports");
        updateIconSidebar(e);
      },
    },
  ];

  const teacherMenuItems: any = (courses: SelectListDto[]) => {
    const teacherMenu = [
      {
        label: "menu",
        isHeader: true,
      },
      {
        id: "dashboard",
        label: "dashboard",
        icon: "ri-apps-2-line",
        link: "/dashboard",
        stateVariables: isDashboard,
        click: function (e: any) {
          e.preventDefault();
          setIsDashboard(!isDashboard);
          setIscurrentState("dashboard");
          updateIconSidebar(e);
        },
      },
    ];
    let subjectMenu: any;
    if (courses && courses.length > 0) {
      subjectMenu = {
        id: "subjects",
        label: "subjects",
        icon: "ri-book-2-fill",
        link: "/#",
        click: function (e: any) {
          e.preventDefault();
          setIsSubjects(!isSubjects);
          setIscurrentState("subjects");
          updateIconSidebar(e);
        },
        stateVariables: isSubjects,
        subItems: [],
      };
      if (courses.find((c) => c.value.en.toLowerCase() === "first course")) {
        subjectMenu.subItems.push({
          id: "first",
          label: "firstCourse",
          link: `/subjects/${CourseEnum.FIRST_COURSE}`,
          parentId: "subjects",
        });
      }
      if (courses.find((c) => c.value.en.toLowerCase() === "second course")) {
        subjectMenu.subItems.push({
          id: "second",
          label: "secondCourse",
          link: `/subjects/${CourseEnum.SECOND_COURSE}`,
          parentId: "subjects",
        });
      }
    }
    if (
      subjectMenu &&
      subjectMenu.subItems &&
      subjectMenu.subItems.length &&
      subjectMenu.subItems.length > 0
    ) {
      teacherMenu.push(subjectMenu);
    }
    return teacherMenu;
  };

  const othersMenuItems: any = [
    {
      label: "menu",
      isHeader: true,
    },
  ];

  const [_user, _setUser] = useState<UserProfileDto | null>(null);

  useEffect(() => {
    if (user) {
      _setUser(user);
    }
  }, [user]);

  const renderMenu = () => {
    if (_user && _user.role && _user.role.key) {
      if (_user.role.key === RoleEnum.SUPER_ADMIN)
        return <React.Fragment>{superAdminMenuItems()}</React.Fragment>;
      if (_user.role.key === RoleEnum.TEACHER_ADMIN)
        return (
          <React.Fragment>{teacherMenuItems(user?.courses)}</React.Fragment>
        );
    }
    return <React.Fragment>{othersMenuItems}</React.Fragment>;
  };

  return renderMenu();
};

export default Navdata;
